import './LoadingBar.scss';

import { useNavigation } from '@remix-run/react';
import React, { useEffect } from 'react';
import { LoadingBarContainer, useLoadingBar } from 'react-top-loading-bar';

const className = 'c-LoadingBar';

const LoadingBarController = ({ children }: { children: React.ReactNode }) => {
  const navigation = useNavigation();
  const loadingBar = useLoadingBar();

  useEffect(() => {
    if (navigation.state !== 'idle' && loadingBar.getProgress() === 0) {
      loadingBar.start();
    }

    if (navigation.state === 'idle' && loadingBar.getProgress() > 0) {
      loadingBar.complete();
    }
  }, [navigation.state]);

  return children;
};

export const LoadingBarProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <LoadingBarContainer props={{ shadow: false, className }}>
      <LoadingBarController>{children}</LoadingBarController>
    </LoadingBarContainer>
  );
};

export default LoadingBarProvider;
